export interface Position {
  abbreviation?: string;
  id: number;
  name: string;
  sport: string;
}

export enum PositionType {
  prospect = "prospect",
  collegePlayer = "college_player"
}
